export function xorKeys(key1: Uint8Array, key2: Uint8Array): Uint8Array {
  const result = new Uint8Array(key1);
  for (let i = 0; i < 32; i++) {
    /* eslint no-bitwise: "off" */
    result[i] ^= key2[i];
  }
  return result;
}
